import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import cookie from 'react-cookies';
import SessionUser from '../Root/session-user';
import { useUnsavedChanges } from '../Root/UnsavedChangesContext';

class Header extends Component {
  constructor(props){
    super(props);
    this.state = {
        security: cookie.load('user'),
        loading: false,
        logout: false,
    } 
  }

  handleLogout(){
    localStorage.clear();
    localStorage.setItem("user", null);
    cookie.remove('user', { path: '/' });
    window.location.href='/';
  }

  handleLogoClick = (e) => {
    e.preventDefault();
    const { requestNavigation, history } = this.props;
    const goHome = () => history.push('/');
    if (requestNavigation) {
        requestNavigation(goHome);
    } else {
        goHome();
    }
  }

  render() {
  return (
    <div className="divMenuContenedor_Panel">
      <div className="divIcoMenu_Panel">
        <ul>
          <li />
          <li />
          <li />
        </ul>
      </div>
      <span className="txtNombre_Panel">
        <a href="/" onClick={this.handleLogoClick}>
          <img src="/static/images/logo_exportemos.png" width="199" alt="Logo Exportemos.pe"/>
        </a>
      </span>
      <SessionUser/>
      <div className="clear" />
    </div>
  );
  }
}

// Wrapper funcional: permite usar el hook useUnsavedChanges y pasarlo como prop
// al Header (que sigue siendo un componente de clase, sin tocar su lógica interna).
const HeaderWithGuard = (props) => {
    const { requestNavigation } = useUnsavedChanges();
    return <Header {...props} requestNavigation={requestNavigation} />;
};

export default withRouter(HeaderWithGuard);
